import type { PortalAssetCounts } from '../../types/portalAsset.js';

// The staff cross-club view (/tools/portal-assets, commit 13). PURE.
//
// ⚠️ A club with a counts doc but no name in the roster is KEPT and labelled,
// never dropped: its photos still need reviewing, and a row that silently
// vanished would hide exactly that. (It means the account was deleted or the
// roster read is stale.)

export type CrossClubRow = PortalAssetCounts & { name: string; known: boolean };

export function crossClubRows(
  counts: readonly PortalAssetCounts[],
  names: ReadonlyMap<string, string>,
): CrossClubRow[] {
  return counts
    .map((c) => {
      const name = names.get(c.accountId);
      return { ...c, name: name ?? `Unknown account (${c.accountId})`, known: name !== undefined };
    })
    .sort((a, b) => b.pending - a.pending || a.name.localeCompare(b.name));
}

export function crossClubTotals(rows: readonly PortalAssetCounts[]): { pending: number; clubsWaiting: number } {
  return {
    pending: rows.reduce((n, r) => n + r.pending, 0),
    clubsWaiting: rows.filter((r) => r.pending > 0).length,
  };
}

/**
 * The COMPLETE id order after moving one category up or down — the reorder
 * route takes the whole list. Out-of-range moves return the order unchanged.
 */
export function moveCategory(ids: readonly string[], index: number, direction: -1 | 1): string[] {
  const target = index + direction;
  if (index < 0 || index >= ids.length || target < 0 || target >= ids.length) return [...ids];
  const next = [...ids];
  [next[index], next[target]] = [next[target]!, next[index]!];
  return next;
}
